import { RootPaths } from "@src/appV2/App/paths";

import { MY_SHIFTS_PATH } from "../path";

export const SHIFT_INVITE_MODAL_PATH = `:shiftInviteId`;

export const SHIFT_INVITE_BOOKED_CONFIRMATION_PATH = `booked-confirmation`;
export const SHIFT_INVITE_BOOKED_CONFIRMATION_FULL_PATH = `${RootPaths.APP_V2_HOME}/${MY_SHIFTS_PATH}/shiftInvites/:shiftInviteId/${SHIFT_INVITE_BOOKED_CONFIRMATION_PATH}`;
